import { GuidanceCountBadge } from '@pages/User/components/GuidanceCountBadge';
import type { ColumnHelper } from '@tanstack/react-table';

enum ShowGuidanceOptions {
  Show = 'SHOW',
  Hide = 'HIDE',
}

const guidanceFilterOptions = [
  { value: ShowGuidanceOptions.Show, label: 'Has guidance run' },
  { value: ShowGuidanceOptions.Hide, label: 'No guidance run' },
];

/**
 * Contract Guidance column. The accessor (and so the sort, and the OpenSearch
 * sort field — the column id IS the indexed field) is the suggestion total;
 * the cell renders open-vs-reviewed from the two root-row counters.
 */
export const guidanceAccessor = <T extends { guidanceFindingsCount?: number; guidanceReviewedCount?: number }>(
  columnHelper: ColumnHelper<T>,
) =>
  columnHelper.accessor((entity) => entity.guidanceFindingsCount, {
    id: 'guidanceFindingsCount',
    header: 'Guidance',
    cell: (cellContext) => (
      <GuidanceCountBadge
        findingsCount={cellContext.row.original.guidanceFindingsCount}
        reviewedCount={cellContext.row.original.guidanceReviewedCount}
      />
    ),
    sortUndefined: 'last',
    meta: {
      filter: {
        label: 'Contract Guidance',
        placeholder: 'Guidance',
        isSingleSelection: true,
        optionsMapping: guidanceFilterOptions,
        order: Number.MAX_SAFE_INTEGER,
      },
      headingCellClassName: '2xl:w-24',
    },
    filterFn: (row, _, selected) => {
      const hasGuidanceRun = row.original.guidanceFindingsCount !== undefined;
      if (selected === ShowGuidanceOptions.Show) {
        return hasGuidanceRun;
      }
      if (selected === ShowGuidanceOptions.Hide) {
        return !hasGuidanceRun;
      }
      return true;
    },
  });
